import React from "react";
import StudentCollegeList from "./CollegeList";
import { useParams } from "react-router-dom";
import Student12TopMenu from "../studentInfo/student12topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InsCollegeListIndex() {
  
  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  return (
    <>
      <Student12TopMenu slug={slug} activeMenu={"CollegeList"} />
      <PageNotes
        type={"Instructor"}
        pageName={"CollegeList12"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <StudentCollegeList slug={slug} />
        </div>
      </div>
    </>
  );
}
